export const reviewDeletedItemStyles = {
	root: {
		display: 'grid',
		alignItems: 'center',
		gridTemplateColumns: '0.75fr 1fr 1fr',
		gap: 2
	},

	label: {
		fontSize: '1rem',
		color: 'text.secondary'
	},

	individualCardRoot: {
		display: 'grid',
		alignItems: 'center',
		gridTemplateColumns: '1fr auto',
		gap: 2,
		width: '75%'
	},

	individuallabel: {
		fontSize: '1rem',
		color: 'text.primary',
		fontWeight: 700,
		minWidth: 0 // Allows truncation (ellipsis) if the screen is very small
	}
};
